export default __webpack_public_path__ + "static/media/fb.1820bf32.svg";